import { createFileRoute } from '@tanstack/react-router';
import { AdminDirectoryPage } from '../../features/directory';

export const Route = createFileRoute('/admin/directory/')({ component: AdminDirectoryPage });
